<template>
  <v-flex
    xs12
    :style="{ 'width': areaDoUsuario ? '40em' : '32.5em' }"
    class="ma-0 pa-0"
    v-if="empresa"
  >
    <div style="color: #074d6e" class="font-weight-medium display-1 mt-4 text-xs-center" v-if="user">
      Insira o CPF do Usuário
    </div>
    <v-text-field
      v-model.lazy="cpf"
      :loading="loading"
      box
      hide-details
      single-line
      color="primary"
      clearable
      class="centered-input display-1 font-weight-black"
      mask="###.###.###-##"
      style="width: 100%;"
    >
    </v-text-field>
    <v-card v-if="areaDoUsuario" width="100%">
      <v-card-title
        class="headline primary white--text justify-center mb-0"
        v-if="!cadastrarCliente"
      >
        {{ cardTitle }}
      </v-card-title>
      <v-btn
        v-if="step !== 1 && step !== 2"
        @click="step = 1"
        block
      >
        <v-icon class="mr-2">mdi-arrow-left</v-icon>
        Voltar
      </v-btn>
      <v-card-text class="ma-0 pa-0">
        <v-stepper v-model="step">
            <v-stepper-items class="ma-0 pa-0">
                <v-stepper-content step="1">
                  <v-layout
                    justify-space-between
                    align-center
                    wrap
                    v-if="!cadastrarCliente && pessoa"
                  >
                    <v-flex xs3>
                      <v-img v-if="pessoa &&pessoa.url_imagem_perfil" :src="pessoa.url_imagem_perfil" width="100%" height="100%" style="border-radius: 50%;"/>
                      <v-icon v-else size="100">mdi-account</v-icon>
                      <h4 class="text-xs-center mt-2" style="width: 100%;">ID: {{ pessoa.id_pessoa }}</h4>
                    </v-flex>
                    <v-flex xs8>
                      <h2 class="headline mt-0">{{ pessoa.nome_completo }}</h2>
                      <v-layout
                        justify-space-around
                        align-center
                        wrap
                        class="mb-4"
                      >
                        <v-flex
                          xs2
                          class="ma-0 pa-0 text-xs-center"
                        >
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                :color="inscricao && inscricao.cliente_plus ? 'secondary' : 'grey'"
                              >
                                mdi-star
                              </v-icon>
                            </template>
                            <span>{{ inscricao && inscricao.cliente_plus ? 'É Plus' : 'Não é Plus' }}</span>
                          </v-tooltip>
                          <h4 :class="inscricao && inscricao.cliente_plus ? 'secondary--text' : 'grey--text'">Plus</h4>
                        </v-flex>
                        <v-flex xs2 class="ma-0 pa-0 text-xs-center">
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" color="success">loyalty</v-icon>
                            </template>
                            <span>Pontos de fidelidade</span>
                          </v-tooltip>
                          <h4 class="success--text">{{ inscricao ? inscricao.pontuacao : 0 }} pts</h4>
                        </v-flex>
                        <v-flex xs2 class="ma-0 pa-0 text-xs-center">
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" :color="inscricao && inscricao.eh_assinante ? 'info' : 'grey'">edit_calendar</v-icon>
                            </template>
                            <span>{{ inscricao && inscricao.eh_assinante ? 'Possui assinatura' : 'Não possui assinatura' }}</span>
                          </v-tooltip>
                          <h4 :class="inscricao && inscricao.eh_assinante ? 'info--text' : 'grey--text'">{{ inscricao &&  inscricao.eh_assinante ? 'Assinante' : 'Não Assinante' }}</h4>
                        </v-flex>
                      </v-layout>
                      <template v-if="pessoa.endereco && empresa">
                        <h4 class="mb-2"><v-icon color="error">mdi-map-marker</v-icon> {{ pessoa.endereco.logradouro }}, {{ pessoa.endereco.numero }}</h4>
                      </template>
                      <h4 v-if="empresa" class="mb-2"><v-icon color="primary">mdi-phone</v-icon> {{ pessoa.telefone | formataTelefone }}</h4>
                    </v-flex>
                    <v-flex xs6 v-if="empresa">
                      <v-btn color="primary" block @click="dialogInformacoes = true">
                          <v-icon class="mr-1">mdi-eye</v-icon>
                          informações
                      </v-btn>
                      <informacoes-usuario
                        v-if="dialogInformacoes"
                        :pessoa="pessoa"
                        :btn="false"
                        :value="dialogInformacoes"
                        @fechar="dialogInformacoes = false"
                      />
                    </v-flex>
                    <v-flex xs6 v-if="empresa">
                      <v-btn color="primary" @click="step = 7" block>
                        <v-icon class="mr-1">edit_calendar</v-icon>
                        Assinatura
                      </v-btn>
                    </v-flex>
                    <v-flex xs6 v-if="empresa">
                      <v-btn color="primary" @click="step = 8" block>
                        <v-icon class="mr-1">add_shopping_cart</v-icon>
                        Fazer Pedido
                      </v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                    <!-- <v-flex xs4>
                      <v-card class="elevation-2 ma-4" height="12em" @click="step = 4" hover>
                        <v-layout justify-center align-center wrap class="pa-3">
                          <v-avatar size="80">
                            <v-icon size="50" :color="compras_pregas.length > 0 ? 'info' : 'grey'">mdi-cart</v-icon>
                            <h4>{{ compras_pregas.length }}</h4>
                          </v-avatar>
                          <h4 class="text-xs-center" style="width: 100%;">Vendas Pré-Pagas</h4>
                        </v-layout>
                      </v-card>
                    </v-flex> -->
                    <v-flex xs4>
                      <v-card class="elevation-2 ma-4" height="12em" @click="step = 3" hover>
                        <v-layout justify-center align-center wrap class="pa-3">
                          <v-avatar size="80">
                            <v-icon size="50" :color="compras_pospagas.length > 0 ? 'success' : 'grey'">payments</v-icon>
                            <h4>{{ compras_pospagas.length }}</h4>
                          </v-avatar>
                          <h4 class="text-xs-center" style="width: 100%;">Vendas Pos-pagas</h4>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <!-- <v-flex xs4>
                      <v-card class="elevation-2 ma-4" height="12em" @click="step = 5" hover>
                        <v-layout justify-center align-center wrap class="pa-3">
                          <v-avatar size="80">
                            <v-icon size="50" :color="premios.length > 0 ? 'error' : 'grey'">mdi-gift</v-icon>
                            <h4>{{ premios.length }}</h4>
                          </v-avatar>
                          <h4 class="text-xs-center" style="width: 100%;">Premios</h4>
                        </v-layout>
                      </v-card>
                    </v-flex> -->
                    <!-- <v-flex xs4 v-if="empresa">
                      <v-card class="elevation-2 ma-4" height="12em" @click="step = 6" hover>
                        <v-layout justify-center align-center wrap class="pa-3">
                          <v-avatar size="80">
                            <v-icon size="50" :color="cashback.length > 0 ? 'secondary' : 'grey'">currency_exchange</v-icon>
                            <h4>{{ cashback.length }}</h4>
                          </v-avatar>
                          <h4 class="text-xs-center" style="width: 100%;">Cashback</h4>
                        </v-layout>
                      </v-card>
                    </v-flex> -->
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="2" class="ma-0 pa-0">
                  <card-cadastro-cliente
                    v-if="cadastrarCliente && cpf && cpf.length === 11"
                    :cpf="cpf"
                    @cadastroRealizado="cadastrarCliente = false" @fechar="cadastrarCliente = false, step = 1, areaDoUsuario = false"
                  />
                </v-stepper-content>
                <v-stepper-content step="3" class="ma-0 pa-0">
                  <compras-em-dinheiro :compras_pospagas="{ results: compras_pospagas }" />
                </v-stepper-content>
                <v-stepper-content step="4" class="ma-0 pa-0">
                  <h3 class="text-xs-center">
                    Não há compras pos-pagas para ler
                  </h3>
                </v-stepper-content>
                <v-stepper-content step="5" class="ma-0 pa-0"></v-stepper-content>
                <v-stepper-content step="6" class="ma-0 pa-0">
                </v-stepper-content>
                <v-stepper-content step="7" class="ma-0 pa-0">
                  <card-cadastro-planos-assinatura
                    v-if="step==7"
                    :pessoa="pessoa"
                    :assinatura="assinatura"
                    :inscricao="inscricao"
                    @assinaturaCancelada="step = 1, pegarInformacoesDoUsuario()"
                    @planoCadastrado="step = 1, pegarInformacoesDoUsuario()"
                  />
                </v-stepper-content>
                <v-stepper-content step="8" class="ma-0 pa-0">
                  <card-cadastro-pedido
                    v-if="step==8"
                    :cliente="pessoa"
                    @cadastroRealizado="step = 1"
                  />
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import CardCadastroCliente from '@/components/CardCadastroCliente.vue'
import ComprasEmDinheiro from '@/components/dialogs/ComprasEmDinheiro.vue'
import CardCadastroPlanosAssinatura from '@/components/CardCadastroPlanosAssinatura.vue'
import CardCadastroPedido from '@/components/CardCadastroPedido.vue'
import InformacoesUsuario from '@/components/dialogs/InformacoesUsuario.vue'
export default {
  components: {
    CardCadastroCliente,
    ComprasEmDinheiro,
    CardCadastroPlanosAssinatura,
    CardCadastroPedido,
    InformacoesUsuario
  },
  data: () => ({
    step: 1,
    id_pessoa: '',
    cpf: '',
    pessoa: undefined,
    assinatura: undefined,
    inscricao: undefined,
    compras_pregas: [],
    compras_pospagas: [],
    premios: [],
    cashback: [],
    cadastrarCliente: false,
    areaDoUsuario: false,
    dialogInformacoes: false
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    },
    cardTitle () {
      switch (this.step) {
        case 1:
          return 'Area do Usuário'
        case 2:
          return 'Cadastro de Cliente'
        case 3:
          return 'Vendas Pos-pagas'
        case 4:
          return 'Vendas Pré-pagas'
        case 5:
          return 'Premios'
        case 6:
          return 'Cashback'
        case 7:
          return 'Assinatura'
        case 8:
          return 'Fazer Pedido'
        default:
          return ''
      }
    }
  },
  watch: {
    cadastrarCliente (newVal) {
      if (newVal) {
        this.step = 2
      }
    },
    cpf (val) {
      if (val.length < 11) {
        this.areaDoUsuario = false
        this.step = 1
        this.cadastrarCliente = false
      // }
      // if (val.length < 11 && this.cadastrarCliente) {
      //   this.step = 1
      //   this.cadastrarCliente = false
      //   this.areaDoUsuario = false
      } else if (val.length === 11) {
        this.pegarInformacoesDoUsuario()
      }
    }
  },
  methods: {
    pegarInformacoesDoUsuario () {
      this.pessoa = undefined
      this.compras_pregas = []
      this.compras_pospagas = []
      this.premios = []
      this.cashback = []
      this.assinatura = undefined
      this.inscricao = undefined
      this.areaDoUsuario = false
      const data = {
        method: 'GET',
        parametros: {
        }
      }
      if (this.cpf) data.parametros.cpf = this.cpf
      if (this.id_pessoa) data.parametros.id_pessoa = this.id_pessoa

      this.$store.dispatch('gerenciarUsuario', data).then(json => {
        this.pessoa = json.pessoa
        this.compras_pregas = json.compras_pregas || []
        this.compras_pospagas = json.compras_pospagas || []
        this.premios = json.premios || []
        this.cashback = json.cashback || []
        this.assinatura = json.assinatura
        this.inscricao = json.inscricao
        this.areaDoUsuario = true
      }).catch(() => {
        this.cadastrarCliente = true
        this.step = 2
        this.areaDoUsuario = true
      })
    }
  }
}
</script>

<style scoped>
.headline {
    padding: 16px 24px;
}

.v-card__actions {
    padding: 16px 24px;
}
</style>
